(function () {
  if (window.__pbCardLevel) return; window.__pbCardLevel = true;
  /* no row levelling: each card's price follows its own content, so short cards beside bags carry no empty block above the price; the buttons still line up at the card foot */
  var KEYS = [];
  var css = '' +
    '.pb-ccol{margin:0 0 10px;min-width:0}' +
    '.pb-ccol__n{display:block;min-width:0;font:500 13px/1.3 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);letter-spacing:0;color:#475583;text-transform:none;overflow-wrap:anywhere}' +
    '.pb-ccol__sw{display:flex;flex-wrap:wrap;gap:10px;margin-top:8px}' +
    '.pb-ccol__b{position:relative;flex:none;width:30px;height:30px;margin:0;padding:0;border:0;border-radius:8px !important;background:#eef3fb;box-shadow:inset 0 0 0 1px rgba(0,48,135,.22);cursor:pointer;-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color:transparent;transition:transform .15s ease,opacity .15s ease}' +
    '.pb-ccol__b::after{content:"";position:absolute;inset:-4px}' +
    '.pb-ccol__b:hover{transform:translateY(-1px)}' +
    '.pb-ccol__b[aria-pressed="true"]{box-shadow:0 0 0 2px #fff,0 0 0 4px #0034d3}' +
    '.pb-ccol__b--t{width:auto;min-width:30px;padding:0 10px;background:#fff;font:600 12.5px/1 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);letter-spacing:0;color:#003087;text-transform:none;white-space:nowrap}' +
    '.pb-ccol__b.is-out{opacity:.5}' +
    '.pb-ccol__b:focus-visible{outline:2px solid #0034d3;outline-offset:4px}' +
    '.pb-ccol-hide{display:none !important}' +
    '.card-product .pb-bc__k{white-space:normal !important;overflow:visible !important;text-overflow:clip !important}' +
    '.pb-ccol-on [data-option-name="colour"],.pb-ccol-on [data-option-name="color"]{display:none !important}' +
    '.pb-eq-empty:empty{display:block;margin:0 0 .625rem}' +
    '.pb-cst{list-style:none;margin:0 0 10px;padding:0;display:grid;grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:6px 10px;min-width:0}' +
    '.pb-cst__i{display:flex;align-items:center;gap:6px;min-width:0;font:500 12.5px/1.25 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);letter-spacing:0;color:#33406b;text-transform:none}' +
    '.pb-cst__i span{min-width:0;overflow-wrap:anywhere}' +
    '.pb-cst__i svg,.pb-cst__i .pb-sk{flex:none;width:16px;height:16px;color:#003087}' +
    '.list-layout .pb-cst{display:flex;flex-wrap:wrap;gap:4px 14px}' +

    '[data-pb-eq="t"] .card__heading,[data-pb-eq="t"] .x-card-title{display:block !important;-webkit-line-clamp:unset !important;overflow:visible !important;text-overflow:clip !important;white-space:normal !important;max-height:none !important}';
  var st = document.createElement('style'); st.setAttribute('data-pb-card-level', ''); st.textContent = css; document.head.appendChild(st);

  function cardOf(el) { return el.closest('.card-product') || el.closest('li') || el.parentElement; }

  /* ── colour pick ── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pb-ccol__b'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var row = b.closest('[data-pb-ccol]'), card = cardOf(row), opt = row.getAttribute('data-opt') || '', val = b.getAttribute('data-pb-ccol-v') || '';
    /* the card renders its info twice (grid and list layouts): keep both copies in step */
    [].forEach.call(card.querySelectorAll('[data-pb-ccol]'), function (rw) {
      [].forEach.call(rw.querySelectorAll('.pb-ccol__b'), function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-pb-ccol-v') === val ? 'true' : 'false'); });
      var n = rw.querySelector('[data-pb-ccol-n]'); if (n) { n.textContent = b.getAttribute('data-name') || val; n.removeAttribute('aria-hidden'); }
    });
    var done = false;
    [].forEach.call(card.querySelectorAll('select'), function (s) {
      if (done || s.name !== opt) return;
      for (var i = 0; i < s.options.length; i++) if (s.options[i].value === val) { s.selectedIndex = i; done = true; break; }
      if (done) s.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (!done) {
      var radios = card.querySelectorAll('input[type="radio"]');
      for (var j = 0; j < radios.length; j++) {
        var r = radios[j];
        if (r.value === val && String(r.name).indexOf(opt + '-') === 0) { if (!r.checked) r.click(); done = true; break; }
      }
    }
    /* the card photo follows the chosen colour */
    var ci = b.getAttribute('data-img'), im = ci && (card.querySelector('img.preview-img') || card.querySelector('a.x-labels-data img'));
    if (im) { im.srcset = b.getAttribute('data-srcset') || ''; im.src = ci; }
    try { card.dispatchEvent(new CustomEvent('pb:card-colour', { detail: { name: b.getAttribute('data-name') || val } })); } catch (er) {}
    later(); setTimeout(later, 700); setTimeout(later, 1600);
  }, true);

  /* ── level rows ── */
  var raf = 0;
  function later() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; level(); }); }
  function level() {
    var cards = [].slice.call(document.querySelectorAll('[data-pb-eq="c"]')).map(cardOf);
    if (!cards.length) return;
    var els = [];
    cards.forEach(function (c) { KEYS.forEach(function (k) { var el = c.querySelector('[data-pb-eq="' + k + '"]'); if (el) { el.style.minHeight = ''; els.push(el); } }); });
    var groups = {}, i;
    cards.forEach(function (c) {
      var r = c.getBoundingClientRect(); if (!r.width) return;
      var box = c.parentElement && c.parentElement.parentElement;
      var key = Math.round(r.top + window.scrollY) + '|' + (box ? (box.__pbk || (box.__pbk = 'g' + (++level.n))) : '');
      var g = groups[key] || (groups[key] = { cards: [], h: {} });
      var m = {};
      KEYS.forEach(function (k) { var el = c.querySelector('[data-pb-eq="' + k + '"]'); m[k] = el ? el.getBoundingClientRect().height : 0; if (el && m[k] > (g.h[k] || 0)) g.h[k] = m[k]; });
      g.cards.push(c);
    });
    Object.keys(groups).forEach(function (key) {
      var g = groups[key]; if (g.cards.length < 2) return;
      g.cards.forEach(function (c) { KEYS.forEach(function (k) { var el = c.querySelector('[data-pb-eq="' + k + '"]'); if (el && g.h[k]) el.style.minHeight = Math.ceil(g.h[k]) + 'px'; }); });
    });
  }
  level.n = 0;
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - lastW) < 2) return; lastW = window.innerWidth; later(); });
  window.addEventListener('load', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  /* cards that arrive or re-render later (filters, load more, variant picks, review stars) */
  if (window.MutationObserver) {
    var t; new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { var tg = list[i].target; if (tg.closest && tg.closest('.card-product, [id*="product-grid"], ul')) { clearTimeout(t); t = setTimeout(later, 150); return; } }
    }).observe(document.body, { childList: true, subtree: true });
  }
  setTimeout(later, 1500); setTimeout(later, 4000);
})();
